<div class="header">
  <h1 mat-dialog-title>
    {{ data.cameraName }}
  </h1>
</div>
<div mat-dialog-content class="flex">
  <!-- Bar Graph -->
  <ng-container *ngIf="data.results">
    <div class="barGraph">
      <ngx-charts-bar-vertical
        [results]="data.results.dailyLprCountChartData"
        [animations]="!data.results.dailyLprCountChartData.length"
        [tooltipDisabled]="false"
        [barPadding]="4"
        [roundEdges]="false"
        [xAxis]="true"
        [yAxis]="true"
        noBarWhenZero="true"
        [maxXAxisTickLength]="32"
      >
      </ngx-charts-bar-vertical>
    </div>
  </ng-container>
  <div mat-dialog-actions class="form">
    <div>
      <form [formGroup]="form">
        <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
      </form>
      <sn-flat-button (click)="submit()">{{ 'vault.filter' | t }}</sn-flat-button>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <sn-flat-button class="closeButton" mat-dialog-close>{{ 'common.close' | t }}</sn-flat-button>
</div>
